// extracted by mini-css-extract-plugin
export default {"root":"_3SAXgaa4Pv5UFaRRy4EBH"};